import { ONBOARDING_STEPS, LABEL_EMAIL, LABEL_FIRST_NAME, LABEL_LAST_NAME, LABEL_PASSWORD, LABEL_CONFIRM_PASSWORD, LABEL_CONFIRM_NEW_PASSWORD, LABEL_RING_MY_PHONE_TM, PORTAL_LOGIN_URL } from "../../../../shared/lib/constants";
export {
  PHONE_NO_CONSENT_TEXT, NO_RECORD_FOUND, PROMO_CODE_DOES_NOT_EXIST, EXPIRED_COUPON,
  THE_PROMO_CODE_HAS_EXPIRED, FREE_AMOUNT, ALPHABETS_REGEX, ALPHABETS_NULLABLE_REGEX,
  FORGET_PASSWORD, COUNTRIES, TRANSACTION_HISTORY_TABLE_HEADERS,
  GRAPHQL_QUERY_POLICY, DATE_FORMAT, ONBOARDING_STEPS,
  // Brand / app
  APP_NAME, APP_NAMES, BRAND_NAME, BRAND_NAME_FULL, COMPANY_NAME, COMPANY_NAME_RIGHTS,
  LABEL_855, LABEL_TM, LABEL_RING_MY_PHONE_TM,
  PAGE_TITLE_WELCOME, PAGE_TITLE_RESET_PASSWORD,
  SPAM_FOLDER_TEXT, VERIFY_EMAIL_BODY_PREFIX, VERIFY_EMAIL_BODY_SUFFIX, VERIFY_EMAIL_TITLE,
  WHODOICALL_URL,
  // Auth page labels / buttons
  BUTTON_TEXT_BACK_TO_LOGIN, BUTTON_TEXT_GET_STARTED, BUTTON_TEXT_LOGIN,
  BUTTON_TEXT_REGISTER, BUTTON_TEXT_RESET_PASSWORD,
  PAGE_SUBTITLE_LOGIN, TEXT_DONT_HAVE_ACCOUNT, TEXT_ALREADY_HAVE_ACCOUNT,
  INVALID_EMAIL, PASSWORD_IS_INVALID, PASSWORD_REGEX, PASSWORD_VALIDATION_MESSAGE,
  ALPHABETS_REGEX_VALIDATION,
  // Form labels
  LABEL_EMAIL, LABEL_PASSWORD, LABEL_CONFIRM_PASSWORD, LABEL_CONFIRM_NEW_PASSWORD,
  LABEL_FIRST_NAME, LABEL_LAST_NAME, LABEL_FULL_NAME, LABEL_PHONE_NUMBER,
  // UI labels
  LABEL_CHANGE_CARD, LABEL_CHANGE_PLAN, LABEL_CONTACT, LABEL_CONTACTS_OPTED_OUT,
  LABEL_CURRENT_PLAN, LABEL_DEACTIVATE_ACCOUNT, LABEL_DELETE_CONTACT,
  LABEL_NOT_AVAILABLE, LABEL_PAYMENT_METHOD,
  LABEL_RING_MY_PHONE_LOGS, LABEL_RING_MY_PHONE_SETTINGS, LABEL_SECURE_PONELESS_SERVICES,
  LABEL_SECURITY_CODE, LABEL_SUBSCRIPTION, LABEL_YEAR_COPYRIGHT_REGISTERED,
  // Buttons
  BUTTON_TEXT_CANCEL, BUTTON_TEXT_CONTINUE, BUTTON_TEXT_CHANGE_PASSWORD, BUTTON_TEXT_CHANGE_PIN,
  BUTTON_TEXT_CLOSE, BUTTON_TEXT_LOADING, BUTTON_TEXT_SAVE, BUTTON_TEXT_UPDATE,
  ACCOUNT_SETTINGS_TAB_DETAILS, ACCOUNT_SETTINGS_TAB_SECURITY, ACCOUNT_SETTINGS_TAB_BILLING,
  LABEL_SECURITY_CODE_PIN,
  BUTTON_TEXT_VERIFY_OTP, BUTTON_TEXT_RESEND_OTP, BUTTON_TEXT_RESENDING,
  // Menu items
  MENU_ITEM_LOGOUT,
  // Misc
  NO_RECORDS, FILTER_STATUS_ACTIVE, ALERT_REFERRAL_SOURCE_UPDATED,
  CUSTOMER_SETTINGS_TAB_CONTACT_LIST,
  // Ring My Phone constants
  LABEL_DATE_AND_TIME, LABEL_NOTIFICATION_TYPE, LABEL_CALL_STATUS, LABEL_LOCATION,
  LABEL_CALL_CHARGES, LABEL_STATUS, MSG_NO_RMP_LOGS_FOUND,
  BUTTON_TEXT_VIEW_ON_MAP, BUTTON_TEXT_VIEW,
  LABEL_ENABLE_LOST_PHONE_RINGER, LABEL_DEFAULT_MESSAGE, LABEL_CUSTOM_MESSAGE,
  // Ring My Phone Info modal
  RING_MY_PHONE_INFO_MODAL, LABEL_PHONE_VANITY, LABEL_PHONE_NUMERIC, LABEL_BRAND_WEBSITE,
  LABEL_SHOW_855_LOGO, PLACEHOLDER_CUSTOM_MESSAGE,
  MSG_TEXT_LIMIT_EXCEEDED, MSG_MESSAGE_TOO_SHORT,
  // Messages
  MSG_EMAIL_SENT_SUCCESSFULLY, MSG_PASSWORD_RESET_SUCCESSFULLY, MSG_PASSWORD_UPDATED_SUCCESSFULLY,
  MSG_NAME_UPDATED_SUCCESSFULLY, MSG_CONTACT_DELETED_SUCCESSFULLY, MSG_CONTACT_ADDED_SUCCESSFULLY,
  MSG_CONTACT_UPDATED_SUCCESSFULLY, MSG_CARD_CHANGED_SUCCESSFULLY, MSG_CARD_UPDATED_SUCCESSFULLY,
  MSG_COUPON_APPLIED_SUCCESSFULLY, MSG_COUPON_CANNOT_BE_APPLIED, MSG_STRIPE_NOT_INITIALIZED,
  MSG_CARD_ELEMENT_NOT_FOUND, MSG_FILL_CARD_DETAILS, MSG_PLEASE_VERIFY_CAPTCHA,
  MSG_PLEASE_SELECT_REFERRAL_SOURCE, MSG_PRIORITY_UPDATED, MSG_PHONE_NUMBER_ADDED_SUCCESSFULLY,
  MSG_PHONE_NUMBER_UPDATED, MSG_PLEASE_CHECK_YOUR_PHONE, MSG_PLEASE_CHECK_YOUR_EMAIL,
  MSG_INVALID_OR_EXPIRED_LINK, MSG_OTP_VERIFIED, MSG_PLAN_UPDATED_SUCCESSFULLY,
  MSG_SUBSCRIPTION_CREATED_SUCCESSFULLY, MSG_TOKEN_VERIFIED, MSG_RMP_INITIATED,
  MSG_RMP_INITIATION_FAILED, MSG_PIN_UPDATED, MSG_PIN_TOO_SHORT, MSG_PLAN_ALREADY_SELECTED,
  MSG_ADD_CARD_FOR_PLAN, MSG_CONTACT_CREATED, MSG_BILLING_ADDRESS_UPDATED,GET_STARTED,
  PAGE_TITLE_SIGNUP_PORTAL, PAGE_SUBTITLE_SIGNUP_PORTAL
} from "../../../../shared/lib/constants";
export const AUTH_TOKEN = 'WDIC_PORTAL_TOKEN';
export const PENDING_PROMO_CODE = 'PENDING_PROMO_CODE';

// APOLLO MESSAGES:
export const UNAUTHORIZED = 'Unauthorized';
export const TOKEN_INVALID = 'Token Invalid';
export const TOKEN_NOT_FOUND = 'Token not found';
export const UNAUTHENTICATED = 'UNAUTHENTICATED';
export const REQUEST_NOT_FOUND = 'Requests not found for current user';
export const CONFLICT_EXCEPTION = 'Conflict Exception';
export const INVALID_AUTH_TOKEN = 'Invalid Authorization Token - Expired or Invalid';
export const NOT_FOUND_EXCEPTION = 'Not Found Exception';
export const SOMETHING_WENT_WRONG = 'Something went wrong';
export const PRECONDITION_FAILED_EXCEPTION = 'Precondition Failed Exception';
export const INVALID_OR_EXPIRED_TOKEN_MESSAGE = 'Sorry! Your token is expired or invalid';
export const INVALID_OR_EXPIRED_OTP = 'Your OTP is invalid or expired';
export const INVALID_TOKEN = 'Invalid Token';
export const USER_DOES_NOT_EXIST = 'User does not exist';
export const THERE_WAS_SOME_ERROR_WHILE_SENDING_EMAIL = 'There was some error while sending email';
export const INCORRECT_EMAIL_OR_PASSWORD = 'Incorrect Email or Password';
export const EMAIL_CHANGED_OR_NOT_VERIFIED_PLEASE_VERIFY_EMAIL = 'Email changed or not verified, please verify your email';
export const THERE_WAS_SOME_ERROR_WHILE_SENDING_SMS = 'There was some error while sending SMS';
export const THE_PROVIDED_NUMBER_IS_NOT_VALID = 'The provided phone number is not valid';
export const BILLING = '/billing';
export const PENDING_PROMO_CODE_INFO = 'is saved and will be auto-applied when you subscribe to a paid plan during onboarding.';
export const PENDING_PROMO_CODE_INFO_PLAN_SELECTION = 'is saved and will be auto-applied when you select a paid plan below.';
export const PHONE_ALREADY_VERIFIED = 'Phone already verified.';
export const CALLER_ID_ALREADY_ADDED = 'Phone number already verified as caller ID.';
export const EDIT_EMAIL_POPUP_VERBIAGE = "We'll email you a verification link using the provided email. Please use that link to verify your email and to log back in to the website.";
export const CARD_INFO_TEXT = "We require a credit card to cover minimal operational costs (e.g., phone calls). You'll only be charged when you use the service";
export const STRIPE_LOAD_ERROR_TEXT = 'Stripe  is not loaded';
export const LINKS = {
  FORGOT_PASSWORD_LINK: '/forgot-password',
  LOGIN_LINK: '/login',
  REGISTER_LINK: '/register',
  RESET_PASSWORD: '/reset-password',
  VERIFY_LINK: '/verify',
  BILLING_LINK: '/billing',
  TERMS_AND_CONDITIONS_LINK: '/terms-and-conditions',
  PRIVACY_POLICY_LINK: '/privacy-policy',
  CHANGE_PLAN_LINK: '/change-plan',
  ACCOUNT_SETTINGS: '/account-settings',
  CONTACT_US_LINK: '/contact-us',
  DASHBOARD_LINK: '/dashboard',
  RING_MY_PHONE_LINK: '/ring-my-phone',
  ONBOARDING_LINK: '/on-boarding',
  ACCOUNT_SETTINGS_LINK: '/account-settings',
  OPT_OUT_LINK: '/opt-out/:id',
  OPT_IN_LINK: '/opt-in/:id',
  SALES_COUPON_PAGE: '/sales-coupon/:code',
  MOBILE_HANDOFF: '/mobile-handoff',
  MOBILE_ACCOUNT: '/mobile-account',
  MOBILE_DASHBOARD: '/mobile-dashboard',
  MOBILE_PAYMENT_HISTORY: '/mobile-payment-history',
  MOBILE_APP_DEEP_LINK: 'whodoicall://',
  PORTAL_LOGIN_URL,
  INSTAGRAM_LINK: import.meta.env.VITE_INSTAGRAM_LINK ?? 'https://www.instagram.com/855whodoicall/',
  FACEBOOK_LINK: import.meta.env.VITE_FACEBOOK_LINK ?? 'https://www.facebook.com/855WhoDoICall/',
  TWITTER_LINK: import.meta.env.VITE_TWITTER_LINK ?? 'https://x.com/855WhoDoICall',
  LINKEDIN_LINK: import.meta.env.VITE_LINKEDIN_LINK ?? 'https://www.linkedin.com/company/855whodoicall-com/',
  YOUTUBE_LINK: import.meta.env.VITE_YOUTUBE_LINK ?? 'https://www.youtube.com/watch?v=EsSSRjqTdsM'
};

export const APP_STORE_LINK = 'https://apps.apple.com/pk/app/855whodoicall/id6754377462';
export const PLAY_STORE_LINK = 'https://play.google.com/store/apps/details?id=com.whodoicall.mobile';

export const LOGIN_FIELDS = [
  {
    title: LABEL_EMAIL,
    fieldType: 'email',
    name: 'email'
  },

  {
    title: LABEL_PASSWORD,
    fieldType: 'password',
    name: 'password'
  }
];

export const RESET_PASSWORD_FIELDS = [
  {
    title: LABEL_PASSWORD,
    fieldType: 'password',
    name: 'newPassword'
  },

  {
    title: LABEL_CONFIRM_NEW_PASSWORD,
    fieldType: 'password',
    name: 'repeatPassword'
  }
];

export const SIGN_UP_FIELDS = [
  {
    title: LABEL_FIRST_NAME,
    fieldType: 'text',
    name: 'firstName',
    xs: 12,
    md: 6
  },

  {
    title: LABEL_LAST_NAME,
    fieldType: 'text',
    name: 'lastName',
    xs: 12,
    md: 6
  },

  {
    title: LABEL_EMAIL,
    fieldType: 'email',
    name: 'email',
    xs: 12,
    md: 12
  },

  {
    title: LABEL_PASSWORD,
    fieldType: 'password',
    name: 'password',
    xs: 12,
    md: 12
  },

  {
    title: LABEL_CONFIRM_PASSWORD,
    fieldType: 'password',
    name: 'passwordAgain',
    xs: 12,
    md: 12
  }
];

export const drawerWidth = 340;

export const DASHBOARD_LINK = [
  { title: 'Dashboard', link: '/dashboard' },
  { title: 'Billing', link: '/billing' },
  { title: LABEL_RING_MY_PHONE_TM, link: '/ring-my-phone' },
] as const;


export enum PlanNickNames {
  FREE_PLAN = 'free plan',
  YEARLY_PLAN = 'Annual',
  MONTHLY_PLAN = 'monthly'
}

export enum CardBrands {
  VISA = 'Visa',
  MASTER = 'Master'
}

export enum SelectedPlanType {
  YEAR = 'year',
  MONTH = 'month'
}

export const STEPS = ONBOARDING_STEPS;

export enum PaymentMethods {
  CARD = 'Credit Card',
  GOOGLE_PAY = 'Google Pay / Apple Pay'
}

export const LABEL_UPGRADE_REQUIRED = 'Upgrade Required';
export const BUTTON_TEXT_UPGRADE_PLAN = 'Upgrade Plan';
export const BUTTON_TEXT_CONFIRM = 'confirm';
export const MSG_RMP_PAID_PLANS_ONLY = 'The "Ring My Phone™" feature is available only on paid plans. Upgrade now to unlock premium features.';
export const TOOLTIP_FREE_PLAN_FEATURE_UNAVAILABLE = 'This feature is not available for free plan users. Upgrade to a paid plan to access it.';
export const TOOLTIP_ENABLE_PHONE_RINGER_FOR_LOCATION = 'Enable "Phone Ringer" in the "Ring My Phone™" tab to permit this feature. It can help you quickly locate your misplaced phone.';
export const TOOLTIP_NO_VIP_CONTACT = 'No VIP contact found — add one to continue.';
export const MSG_CONFIRM_RING_PHONE = 'Are you sure you want to ring your phone?';
export const LABEL_WELCOME_TO = 'Welcome to ';
export const TOOLTIP_GO_TO_DASHBOARD = 'Go to Dashboard';
export const LABEL_ONBOARDING_SUBTITLE_PREFIX = "It only takes a moment. And it'll make your time with ";
export const LABEL_ONBOARDING_SUBTITLE_SUFFIX = '.com even better.';

export const MSG_MAX_CONTACTS = (max: number | string) => `You can save up to ${max} preset contacts.`;
export const TOOLTIP_MAX_CONTACTS_INFO = 'Call them from any phone by dialing 855-WHO-DO-I-CALL (or 855-946-3642) followed by your secure calling PIN. Once protected, even when using a different phone, your contacts will see your usual number on their caller ID.';

export const MSG_REMOVE_CONTACTS_BEFORE_DOWNGRADE = (count: number) =>
  `Please remove ${count} contact(s) first.`;
